import { fetchPost, fetchGet, fetchPut } from '../services/Apiservice'

/**
 * Login user through API
 */
export const authLogin = (email, password) => {
    return fetchPost('/login', { email, password })
        .then((res) => {
            return res
        })
        .catch((res) => {
            throw res
        })
}

/**
 * Register new user through API
 */
export const authRegister = (name, email, password, passwordConfirmation, role) => {
    return fetchPost('/register', {
        name,
        email,
        password,
        password_confirmation: passwordConfirmation,
        role
    })
        .then((res) => {
            return res
        })
        .catch((res) => {
            throw res
        })
}

/**
 * Logout user through API
 */
export const authLogout = () => {
    return fetchPost('/logout')
        .then((res) => {
            return res
        })
        .catch((res) => {
            throw res
        })
}

/**
 * Get current user from API
 */
export const authGetUser = () => {
    return fetchGet('/user')
        .then((res) => {
            return res.data.user
        })
        .catch((res) => {
            throw res
        })
}

/**
 * Update user profile through API
 */
export const authUpdateProfile = (name, email) => {
    return fetchPut('/user/profile', { name, email })
        .then((res) => {
            return res
        })
        .catch((res) => {
            throw res
        })
}

/**
 * Forgot password
 */
export const authForgotPassword = (email) => {
    return fetchPost('/forgot-password', { email })
        .then((res) => {
            return res
        })
        .catch((res) => {
            throw res
        })
}

/**
 * Reset password
 */
export const authResetPassword = (token, email, password, passwordConfirmation) => {
    return fetchPost('/reset-password', {
        token,
        email,
        password,
        password_confirmation: passwordConfirmation
    })
        .then((res) => {
            return res
        })
        .catch((res) => {
            throw res
        })
}

// Backward compatibility export
export const authApi = {
    login: authLogin,
    register: authRegister,
    logout: authLogout,
    getUser: authGetUser,
    updateProfile: authUpdateProfile,
    forgotPassword: authForgotPassword,
    resetPassword: authResetPassword,
}
